















































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import Modal from '../../../../../components/Modal.vue'
import Icon from '@/components/Icon.vue'
import ScrollView from '@/components/ScrollView.vue'
import InputDateRangePicker from '@/components/inputs/InputDateRangePicker.vue'
import SortableDirective from '@/directives/sortable'
import Input from '@/components/inputs/Input.vue'
import DateInput2 from '@/components/inputs/DateInput2.vue'
import { isString, IStatement, IStatementLineItem } from '@zunta/configurations'
import { Watch } from 'vue-property-decorator'
import { StatementModule } from '@/store/modules/statement.module'
import { getModule } from 'vuex-module-decorators'
import MoneyInputV3 from '@/components/inputs/MoneyInputV3.vue'
import Confirm from '@/components/Confirm.vue'
import Card from '@/components/Card.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import { ISelectItem } from '@/interfaces'
import RadioGroup from '@/components/RadioGroup.vue'
import { minus, plus } from '@/utils/helpers'

const moment = require('moment')
const sortBy = require('lodash.sortby')

@Component({
  directives: {
    sortable: new SortableDirective()
  },
  components: {
    RadioGroup,
    LoaderWrapper,
    Checkbox,
    Card,
    Confirm,
    MoneyInputV3,
    DateInput2,
    Input,
    InputDateRangePicker,
    ScrollView,
    Icon,
    Modal
  },
  props: {
    statement: {
      required: true
    }
  }
})
export default class EditStatementModal extends Vue {
  statementModuleInstance: StatementModule = getModule(StatementModule, this.$store)
  dueDate: Date | string = ''
  isError: boolean = false
  isErrorCase: boolean = false
  isErrorDueDate: boolean = false
  isLoading: boolean = false
  forceUpdater: number = 1
  showConfirmRevertModal: boolean = false

  includePreviousBreakdown: boolean = false
  revertForAll: boolean = false
  statementDueDate: number = 0

  lineItems: Partial<IStatementLineItem> [] = []

  get statementID () {
    return this.$route.params.statement
  }

  get selectedBatch () {
    return this.$store.state.statement.selectedBatch
  }

  get statementList () {
    return this.$store.state.statement.statementList || []
  }

  get radioOptions (): ISelectItem[] {
    return [
      {
        key: '0',
        value: 0,
        content: ''
      },
      {
        key: '100',
        value: 100,
        content: 'Past Due'
      },
      {
        key: '101',
        value: 101,
        content: 'Upon Receipt'
      }
    ]
  }

  get selectedStatement (): IStatement | null {
    if (this.statementList && this.statementList.length) {
      return this.statementList.find((statement: IStatement) => (
          statement.id === parseInt(this.statementID, 10)
      ))
    }
    return null
  }

  get isEverythingValid () {
    return !this.isError && !this.isErrorCase && !this.isErrorDueDate
  }

  async getLineItems () {
    console.log('include', this.includePreviousBreakdown)
    try {
      this.isLoading = true
      const result = await this.statementModuleInstance.fetchStatementLineItems({
        statementId: this.$props.statement.id,
        includePreviousBreakdown: this.includePreviousBreakdown
      })
      this.lineItems = result ? result.map((item: any) => {
        return {
          ...item,
          dateTo: item.dateFrom && !item.dateTo ? item.dateFrom : item.dateTo
        }
      }) : []
      // this.includeAdjustmentsBreakdown = this.selectedStatement && this.selectedStatement.includeAdjustmentsBreakdown ? this.selectedStatement.includeAdjustmentsBreakdown : false
    } finally {
      this.validate()
      this.isLoading = false
    }
  }

  sortByDate () {
    if (!this.lineItems.length) {
      return
    }
    this.lineItems.sort((a: any, b: any) => (moment(a.billingDate, 'YYYY-MM-DD').unix() - moment(b.billingDate, 'YYYY-MM-DD').unix()))
    this.lineItems = this.lineItems.map((item: any, index: number) => {
      return { ...item, order: index + 1 }
    })
    this.updateRunningBalance()
    this.forceUpdater++
  }

  @Watch('lineItems', { deep: true })
  validate () {
    if (!this.lineItems.length) {
      this.isError = true
      return
    }
    let localValid = false
    this.lineItems.forEach((item: any) => {
      if (!item.description) {
        localValid = true
      }
      if (!item.billingDate) {
        localValid = true
      }
      if (!item.description) {
        localValid = true
      }
    })

    this.isError = localValid
  }

  scrollTo (offsetTop: number = 0) {
    const area = document.getElementById('drag-scroll-area')
    if (!area) return
    area.scrollTop = offsetTop * 2
  }

  validateCase (lineItem: IStatementLineItem) {
    this.lineItems.forEach((item: any, index) => {
      if (!item.chargeAmount && !item.creditAmount) {
        if (lineItem === item) {
          // @ts-ignore
          this.$refs['charge' + this.forceUpdater + '-' + index][0].isError = true
          // @ts-ignore
          this.$refs['credit' + this.forceUpdater + '-' + index][0].isError = true
        }
        this.isErrorCase = true
      } else {
        // @ts-ignore
        this.$refs['charge' + this.forceUpdater + '-' + index][0].isError = false
        // @ts-ignore
        this.$refs['credit' + this.forceUpdater + '-' + index][0].isError = false
        this.isErrorCase = false
      }
    })
  }

  @Watch('dueDate')
  validateDueDate () {
    this.isErrorDueDate = !this.dueDate
    // @ts-ignore
    this.$refs['dueDate'].isError = this.isErrorDueDate
  }

  autoSetChargeAmount (item: IStatementLineItem) {
    if (item.unitAmount && item.numberOfUnits) {
      const newValue = item.unitAmount * item.numberOfUnits
      this.updateChargeAmount(item, newValue)
    }
  }

  updateDueDate (value: Date | string) {
    this.dueDate = value
  }

  updateBillingDate (item: IStatementLineItem, value: Date | string) {
    if (!value) {
      item.billingDate = ''
      return
    }
    item.billingDate = moment(value).format('YYYY-MM-DD')
  }

  updateDateRange (item: IStatementLineItem, value: Array<Date | string>) {
    if (value) {
      const [dateFrom, dateTo] = value
      item.dateFrom = dateFrom
      item.dateTo = dateTo
    } else {
      this.clearDateRange(item)
    }
  }

  updateChargeAmount (item: IStatementLineItem, value: any) {
    item.chargeAmount = parseFloat(value)
    this.validateCase(item)
    this.updateRunningBalance()
    if (item.chargeAmount) {
      this.updateCreditAmount(item, null)
      // @ts-ignore
      item.chargeAmountDisabled = false
    } else {
      // @ts-ignore
      item.chargeAmountDisabled = true
    }
    this.setItemDisability(item)
  }

  updateCreditAmount (item: IStatementLineItem, value: any) {
    item.creditAmount = parseFloat(value)
    this.validateCase(item)
    this.updateRunningBalance()
    if (item.creditAmount) {
      this.updateChargeAmount(item, null)
      // @ts-ignore
      item.creditAmountDisabled = false
    } else {
      // @ts-ignore
      item.creditAmountDisabled = true
    }
    this.setItemDisability(item)
  }

  setItemDisability (item: IStatementLineItem) {
    if (!item.creditAmount && !item.chargeAmount) {
      // @ts-ignore
      item.creditAmountDisabled = false
      // @ts-ignore
      item.chargeAmountDisabled = false
    } else if (!item.creditAmount && item.chargeAmount) {
      // @ts-ignore
      item.creditAmountDisabled = true
    } else if (item.creditAmount && !item.chargeAmount) {
      // @ts-ignore
      item.chargeAmountDisabled = true
    }
  }

  updateRunningBalance () {
    let balance: number = 0
    this.lineItems.forEach((item: any, index) => {
      // @ts-ignore
      const charge = this.lineItems[index].chargeAmount ? +this.lineItems[index].chargeAmount : 0
      // @ts-ignore
      const credit = this.lineItems[index].creditAmount ? +this.lineItems[index].creditAmount : 0
      balance = minus(plus(balance, charge), credit)
      this.lineItems[index].runningBalance = balance
    })
  }

  clearDateRange (item: IStatementLineItem) {
    item.dateFrom = ''
    item.dateTo = ''
  }

  insert (arr: any[], index: number, newItem: any) {
    return [
      // part of the array before the specified index
      ...arr.slice(0, index),
      // inserted item
      newItem,
      // part of the array after the specified index
      ...arr.slice(index)
    ]
  }

  updateSelectedOrder (event: any) {
    const { oldIndex, newIndex } = event
    let lineItems = [...this.lineItems]
    const payerType = { ...lineItems[oldIndex] }
    lineItems.splice(oldIndex, 1)
    lineItems = this.insert(lineItems, newIndex, payerType)
    this.lineItems = lineItems
    this.updateOrderIndex()
  }

  updateOrderIndex () {
    this.lineItems.forEach((item: any, index) => {
      this.lineItems[index].order = index
    })
    this.updateRunningBalance()
    this.forceUpdater++
  }

  sortByOrder () {
    this.lineItems = sortBy(this.lineItems, 'order')
  }

  addLineItem () {
    this.lineItems.push({
      statementId: this.$props.statement.id,
      description: '',
      order: this.lineItems.length + 1,
      dateFrom: '',
      dateTo: '',
      billingDate: '',
      numberOfUnits: null,
      unitAmount: null,
      chargeAmount: null,
      creditAmount: null,
      runningBalance: 0
    })
    this.updateOrderIndex()

    this.isError = true
    this.isErrorCase = true
    this.forceUpdater++

    const list = document.querySelector('.modal_content .drag-list')
    if (!list) return
    this.$nextTick(() => {
      // @ts-ignore
      this.scrollTo(list.offsetHeight)
    })
  }

  removeLineItem (order: number) {
    this.lineItems = this.lineItems.filter((item: any) => item.order !== order)
    this.updateOrderIndex()
    setTimeout(() => {
      this.validate()
      this.forceUpdater++
    }, 100)
  }

  close () {
    this.$emit('close')
  }

  async updateLineItems (forAll: boolean = false) {
    const lineItems = this.lineItems.map((item: any) => {
      return {
        ...item,
        numberOfUnits: parseInt(item.numberOfUnits) ? item.numberOfUnits : null,
        unitAmount: parseFloat(item.unitAmount) ? item.unitAmount : null,
        chargeAmount: parseFloat(item.chargeAmount) ? item.chargeAmount : null,
        dateTo: item.dateFrom && item.dateTo && item.dateFrom === item.dateTo ? null : item.dateTo
      }
    })

    this.$eventBus.$emit('loading:enable', { message: 'Updating' })
    const response = await this.statementModuleInstance.updateStatementLineItems({
      statementId: this.$props.statement.id,
      payload: {
        billingDate: this.dueDate,
        lineItems: lineItems,
        forAll: forAll,
        dueDate: this.statementDueDate,
        includePreviousBreakdown: this.includePreviousBreakdown
      }
    })
    if (!isString(response)) {
      if (response && response.message) {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-error-color)',
          message: Array.isArray(response.message) ? response.message.join('\n') : response.message,
          header: `Edit Line Items`,
          icon: 'warning'
        })
      }
    }
    setTimeout(() => {
      this.$eventBus.$emit('loading:disable')
    }, 400)
  }

  async submit (forAll: boolean = false) {
    try {
      this.isLoading = true
      let scrollToFirstInvalid: number | null = null
      const lineItemHeight: number = 80
      this.validate()
      this.lineItems.forEach((item: any, index) => {
        const fields = ['description-', 'date-']
        fields.forEach((field: string) => {
          // @ts-ignore
          const ref = this.$refs[field + this.forceUpdater + '-' + index][0]
          ref.isError = !ref.value
          if (scrollToFirstInvalid === null && !ref.value) scrollToFirstInvalid = index
        })
        // this.validateCase(item)

        if (!item.chargeAmount && !item.creditAmount) {
          // @ts-ignore
          this.$refs['charge' + this.forceUpdater + '-' + index][0].isError = true
          // @ts-ignore
          this.$refs['credit' + this.forceUpdater + '-' + index][0].isError = true
          scrollToFirstInvalid = index
          this.isErrorCase = true
        }
      })
      if (scrollToFirstInvalid !== null) {
        const scrollTo = scrollToFirstInvalid - 1 > 0 ? scrollToFirstInvalid - 1 : 0
        this.scrollTo(lineItemHeight * scrollTo)
      }

      this.validateDueDate()

      if (!this.isEverythingValid) return

      await this.updateLineItems(forAll)
      this.$emit('update')
    } catch (e) {
      console.error('error', e)
    } finally {
      this.isLoading = false
    }
  }

  async mounted () {
    this.includePreviousBreakdown = this.selectedStatement && this.selectedStatement.includePreviousBreakdown ? this.selectedStatement.includePreviousBreakdown : false
    await this.getLineItems()
    this.dueDate = this.$props.statement && this.$props.statement.billingDate
        ? moment(this.$props.statement.billingDate).format('MM/DD/YYYY')
        : moment().format('MM/DD/YYYY')
    this.statementDueDate = this.$props.statement.dueDate || 0
    this.$nextTick(() => {
      this.forceUpdater++
    })
    this.lineItems.forEach((item: any) => {
      this.setItemDisability(item)
    })
  }

  toggleConfirmRevertForCurrentOrAll (value: boolean) {
    this.revertForAll = value
    this.toggleConfirmRevertModal(true)
  }

  toggleConfirmRevertModal (value: boolean) {
    if (this.$props.statement.wasManuallyModified) {
      this.showConfirmRevertModal = value
    } else {
      this.close()
    }
  }

  revertToOriginal () {
    this.$emit('revertToOriginal', this.revertForAll)
  }
}
